import { render } from "./TaskReminders.vue?vue&type=template&id=46ca46a4&scoped=true&ts=true"
import script from "./TaskReminders.vue?vue&type=script&lang=ts"
export * from "./TaskReminders.vue?vue&type=script&lang=ts"

import "./TaskReminders.vue?vue&type=style&index=0&id=46ca46a4&scoped=true&lang=css"

import exportComponent from "../../../../sf-playbook-app/APP/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46ca46a4"]])

export default __exports__